<template>
  <crud-show :title="title" :open="open" @close="$emit('close')">
    <v-card-text>
      <oferta-show-data :item="item" />
    </v-card-text>
  </crud-show>
</template>

<script>
import OfertaShowData from "./OfertaShowData";
import { CrudShow } from "@dracul/common-frontend";

export default {
  name: "OfertaShow",
  components: { CrudShow, OfertaShowData },
  props: {
    open: { type: Boolean, default: true },
    item: { type: Object, required: true },
  },
  data() {
    return {
      title: "oferta.showing",
    };
  },
};
</script>

